import { type ServiceMethod } from '@/application/interfaces/service';
import { type Metadata } from '@/infra/services/model';

export type SearchParams = {
  page: number;
};

export type Response = {
  data: Metadata;
};

const getProductsMetadata: ServiceMethod<Response, SearchParams> =
  (httpClient) => async (data) => {
    const { page } = data;

    const { body: response } = await httpClient.get<
      Response,
      undefined,
      SearchParams
    >('/api/v3/seo/products/metadata', {
      searchParams: {
        page,
      },
    });

    return response;
  };

export default getProductsMetadata;
